import {Component, Input, OnInit} from '@angular/core';
import {Serializer} from "../../../../shared/interfaces/serializer";
import {DateFormat, NumberFormat, User} from "../../../../shared/interfaces/user";
import {FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {ProfileService} from "../../../../shared/services/profile.service";
import {SelectOption} from "../../../../shared/interfaces/form";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {ProfileStore} from "../../../../shared/store/profile/profile.store";
import {TwoFactorAuthTypes} from "../../../../shared/interfaces/profile";
import {updateProfile, updateProfileAvatar} from "../../../../shared/store/profile/profile.actions";
import {FormUtils} from "../../../../shared/libraries/form-utils";
import {selectProfileLoading} from "../../../../shared/store/profile/profile.selectors";

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.scss']
})

export class ProfileFormComponent implements OnInit {
  @Input('profile') protected profile: Serializer<User>;
  @Input('userForm') protected userForm: FormGroup;

  public readonly validators: Array<ValidatorFn> = [Validators.required];

  public user: User;

  protected readonly environment = environment;

  public readonly hintDateFormat$: Observable<string> = this._profileStore.hintDateFormat$;
  public readonly hintNumberFormat$: Observable<string> = this._profileStore.hintNumberFormat$;
  public readonly authToken$: Observable<string> = this._profileStore.authToken$;
  public readonly userForm$: Observable<FormGroup> = this._profileStore.userForm$;
  public readonly securityForm$: Observable<FormGroup> = this._profileStore.securityForm$;
  public readonly twoFactorAuthTypes$: Observable<SelectOption<TwoFactorAuthTypes, string>[]> = this._profileStore.twoFactorAuthTypes$;
  public readonly twoFactorAuthTypeDisabled$: Observable<SelectOption<TwoFactorAuthTypes, string>[]> = this._profileStore.twoFactorAuthTypeDisabled$;
  public readonly numberFormats$: Observable<SelectOption<NumberFormat, string>[]> = this._profileStore.numberFormats$;
  public readonly dateFormats$: Observable<SelectOption<DateFormat, string>[]> = this._profileStore.dateFormats$;
  public readonly mobileCountryCallingCodes$: Observable<SelectOption<string, string>[]> = this._profileStore.mobileCountryCallingCodes$;
  public readonly loading$: Observable<boolean> = this._store.select(selectProfileLoading);

  constructor(
    public readonly profileS: ProfileService,
    private readonly _store: Store,
    private readonly _profileStore: ProfileStore
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  public onGlobalInformationSave(): void {
    this._store.dispatch(updateProfile({ update: {
      ...FormUtils.getValues(this.userForm.value),
      phone_number: this._profileStore.getPhoneNumber(this.userForm)
    }}));
  }

  public onImageAdded(image: string): void {
    this._store.dispatch(updateProfileAvatar({
      avatar: image
    }));
  }
}
